module.exports = "../images/fishing-lodge-3-26.jpg?v=51ea482";